import React, { useContext, useRef, useState } from "react";
import { Box, Card, CardContent } from "@mui/material";
import otpImg from "../../../assest/Otp.svg";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialInput from "../../../components/MaterialInput";
import MaterialBox from "../../../components/MaterialBox";
import MaterialButton from "../../../components/MaterialButton";
import colors from "../../../assest/theme/base/colors";
import { useNavigate } from "react-router-dom";
import logo from "../../../assest/images/logo.jpg";
import { OtpVeify } from "../Mutation";
import { postItem } from "../../../BaseUrl";
import MessagePopup from "../../Utils/MessagePopup";
import { UserContext } from "../../usercontext/usercontext";

export default function OtpVerify() {
  const navigate = useNavigate();
  const { email } = useContext(UserContext);
  const [otp, setOtp] = useState(Array(6).fill(""));
  const inputsRef = useRef([]);
  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success", // 'success' or 'error'
  });

  const handleChange = (value, index) => {
    if (isNaN(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value !== "" && index < otp.length - 1) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const data = e.clipboardData.getData("text").split("");
    const newOtp = [...otp];

    data.forEach((char, i) => {
      if (i < otp.length && !isNaN(char)) {
        newOtp[i] = char;
      }
    });

    setOtp(newOtp);
    inputsRef.current[Math.min(data.length - 1, otp.length - 1)].focus();
  };

  const isDisabled = otp.some((digit) => digit === "");

  const OtpVerify = async () => {
    const variables = {
      email: email,
      otp: otp.join(""),
    };

    try {
      const response = await postItem(OtpVeify, variables );
      if (response?.verifyOtp?.success === true) {
        setPopup({
          open: true,
          message: "OTP verify Successfully",
          severity: "success",
        });
        setTimeout(() => {
          navigate("/confirm-password");
        }, 1000);
      } else {
        setPopup({
          open: true,
          message: response?.verifyOtp?.message,
          severity: "error",
        });
      }
    } catch (error) {
      console.error(error);
      setPopup({
        open: true,
        message: error,
        severity: "error",
      });
    } finally {
    }
  };
  return (
    <Box>
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <Box sx={{ p: 4 }}>
        <img
          src={logo}
          alt="log img"
          style={{ height: "60px", width: "140px" }}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "60vh",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-evenly",
            gap: 2,
            width: "100%",
          }}
        >
          {/* Illustration Section */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <img src={otpImg} alt="otpImg" />
          </Box>

          {/* Form Section */}
          <Card
            sx={{
              flex: 1,
              maxWidth: 400,
              padding: 4,
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            <CardContent>
              <MaterialTypography variant="h6" fontWeight="bold" gutterBottom>
                OTP Code Verification
              </MaterialTypography>
              <MaterialTypography
                sx={{ marginBottom: 2, color: "#989898", fontSize: "14px" }}
              >
                A Six digit code has been sent to your Mail ID. Enter the code
                below to verify
              </MaterialTypography>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap={2}
              >
                <Box display="flex" justifyContent="center" gap={1}>
                  {otp.map((digit, index) => (
                    <MaterialInput
                      key={index}
                      value={digit}
                      inputProps={{
                        maxLength: 1,
                        style: { textAlign: "center" },
                      }}
                      inputRef={(el) => (inputsRef.current[index] = el)}
                      onChange={(e) => handleChange(e.target.value, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      onPaste={handlePaste}
                      variant="outlined"
                      size="small"
                    />
                  ))}
                </Box>
              </Box>
              <MaterialBox
                sx={{ display: "flex", justifyContent: "center" }}
                my={2}
              >
                <MaterialButton
                  variant="contained"
                  onClick={() => {
                    OtpVerify();
                  }}
                  disabled={isDisabled}
                  sx={{
                    background: colors.buttonColor,
                    color: "#fff",
                    textTransform: "capitalize",
                  }}
                >
                  Verify
                </MaterialButton>
              </MaterialBox>
            </CardContent>
          </Card>
        </Box>
      </Box>
    </Box>
  );
}
